export default __webpack_public_path__ + "static/favicon-f524d29fc8a27f7cdcc697bd1aac11c9.ico";